import useAjaxSelect2Store from "@scripts/hooks/use-ajax-select2-store";

export default (initial = {}) => ({
    storeName: initial.store ?? null,
    storeProp: initial.storeProp ?? (initial.singleChoice ? null : "selectedUsers"),
    singleChoice: Boolean(initial.singleChoice ?? false),
    placeholder: initial.placeholder ?? "Виберіть користувача",
    selectHook: null,
    selectedUsers: [],
    selectedUser: null,

    init() {
        this.$nextTick(() => this._syncMultipleAttribute());

        const valueProp = this.singleChoice ? "selectedUser" : "selectedUsers";
        if (typeof this[valueProp] === "undefined") {
            this[valueProp] = this.singleChoice ? null : [];
        }

        this.selectHook = useAjaxSelect2Store(this, {
            ref: "usersSelect",
            storeName: this.storeName,
            storeProp: this.storeProp || valueProp,
            valueProp,
            restPath: "users",
            multiple: this.singleChoice,
            placeholder: this.placeholder,
        });
    },

    _syncMultipleAttribute() {
        const el = this.$refs?.usersSelect;
        if (!el) return;

        if (this.singleChoice) {
            el.removeAttribute("multiple");
        } else {
            el.setAttribute("multiple", "multiple");
        }
    },
});
